export const visit = (vm, at) => {
vm(require("./availability/fr.lyaml"));
vm(require("./typical-response-time/fr.lyaml"));
vm(require("./default/fr.lyaml"));
at({ "fr": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "OK" } } });
};